import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Form, Skeleton, Col, Row, message } from 'antd';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import CallbackModal from 'components/CallbackModal';
import formBillerEdit from '../../components/BillerForm/BillerForm.components';
import text from './BillerUpdate.page.translation';
import billerRoute from '../../route';
import './BillerUpdate.style.less';

// Initiate FORM
const BillerEditForm = Form.create()(formBillerEdit);

export default class BillerUpdate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalNotification: false,
      billerId: '',
      isSuccess: false,
      seriesResult: [],
    };
  }

  componentDidMount() {
    // Check Props Availabel is is Not Then request
    const billerID = this.props.match.params.id;
    const { biller } = this.props;
    // Load API
    if (_.isEmpty(biller)) {
      this.props.getBiller(billerID, this.onActionGetBiller);
    } else {
      this.onActionGetBiller({}, 'success');
    }

    const getListBankParam = {
      page_num: 1,
      page_size: 150,
    };
    this.props.getListBank(getListBankParam);
    this.props.getListPaymentMethod();
    this.props.getBlacklistPaymentMethodInBillers();
  }

  onActionGetBiller = (res, status) => {
    const defaultParam = 'page_num=1&page_size=50';
    if (status === 'success') {
      this.props.getListService(defaultParam);
      this.props.getListForm(defaultParam);
    } else {
      message.error({
        content: 'Whoops, Something error on load api!',
        key: 'actionGetBillerLoader',
      });
    }
  };

  onSubmitForm = (params, isSyncConsent) => {
    const billerID = this.props.match.params.id;

    this.props.billerUpdate(
      billerID,
      params,
      isSyncConsent,
      this.onActionBillerUpdate,
    );
  };

  onArchiveBiller = isSyncConsent => {
    const billerID = this.props.match.params.id;
    this.props.billerArchive(
      billerID,
      true,
      isSyncConsent,
      this.onActionBillerUpdate,
    );
  };

  cancelSubmit = () => {
    const billerID = this.props.match.params.id;
    const to = billerRoute.BILLERS_DETAIL.replace(':id', billerID);
    this.props.history.push(to);
  };

  onActionBillerUpdate = (id, status, seriesResult) => {
    this.setState({
      modalNotification: true,
      isSuccess: status,
      billerId: id,
      seriesResult,
    });
  };

  _skeletonLoader = () => (
    <Row gutter={24}>
      <Col className="gutter-row" span={12}>
        <div className="gutter-box">
          <Skeleton
            active
            loading
            paragraph={{
              rows: 6,
              width: ['100%', '100%', '100%', '80%', '50%', '30%'],
            }}
            title={false}
          />
        </div>
      </Col>
      <Col className="gutter-row" span={12}>
        <div className="gutter-box">
          <Skeleton
            active
            loading
            paragraph={{
              rows: 6,
              width: ['100%', '100%', '100%', '80%', '50%', '30%'],
            }}
            title={false}
          />
        </div>
      </Col>
    </Row>
  );

  _renderForm = () => {
    const {
      biller,
      match,
      listPaymentMethod,
      blacklistPaymentMethodInBillers,
    } = this.props;
    const renderWhenReady = !match.params.id || biller.id;
    return renderWhenReady ? (
      <BillerEditForm
        {...this.props}
        billerDetail={biller}
        listPaymentMethod={listPaymentMethod}
        blacklistPaymentMethodInBillers={blacklistPaymentMethodInBillers}
        onSubmit={this.onSubmitForm}
        cancelSubmit={this.cancelSubmit}
        onArchive={this.onArchiveBiller}
        formType="edit"
      />
    ) : (
      this._skeletonLoader()
    );
  };

  _renderBreadCrumb = () => (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Link to="/">Home</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={billerRoute.BILLERS}>Billers</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={`${billerRoute.BILLERS}/${this.props.match.params.id}`}>
          View Billers
        </Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>Edit</Breadcrumb.Item>
    </Breadcrumb>
  );

  goToBillerDetail = billerId => {
    const to = billerRoute.BILLERS_DETAIL.replace(':id', billerId);
    this.props.history.push(to);
  };

  onCloseModalNotification = () => {
    const { isSuccess, billerId } = this.state;
    if (isSuccess) {
      this.goToBillerDetail(billerId);
    } else {
      this.setState({
        modalNotification: false,
        isSuccess: false,
      });
    }
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    const { modalNotification, seriesResult } = this.state;

    return (
      <div className="main-content edit-biller">
        <div className="breadcrumb-wrapper">{this._renderBreadCrumb()}</div>

        <div className="white-box-wrapper">
          <div className="title-head">
            <span className="title">{formatMessage(text.billerEdit)}</span>
          </div>

          <div className="inner-wrapper">{this._renderForm()}</div>
        </div>

        <CallbackModal
          modalVisible={modalNotification}
          onClose={this.onCloseModalNotification}
          btnText="Close"
          seriesResult={seriesResult}
        />
      </div>
    );
  }
}

BillerUpdate.propTypes = {
  intl: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  listService: PropTypes.array,
  listForm: PropTypes.array,
  listTnc: PropTypes.array,
  biller: PropTypes.object,
  getBiller: PropTypes.func,
  getListService: PropTypes.func,
  getListForm: PropTypes.func,
  getListTnc: PropTypes.func,
  billerUpdate: PropTypes.func,
  billerArchive: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
  getListBank: PropTypes.func,
  getListPaymentMethod: PropTypes.func,
  getBlacklistPaymentMethodInBillers: PropTypes.func,
  listPaymentMethod: PropTypes.array,
  blacklistPaymentMethodInBillers: PropTypes.object,
};
